import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Typography } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AIChatAnalyzingIndicator = function AIChatAnalyzingIndicator() {
  var dotAnimationStyles = {
    display: 'inline-block',
    width: 6,
    height: 6,
    borderRadius: '9999px',
    backgroundColor: '#0E35D1',
    opacity: 0.35,
    transform: 'scale(0.45)',
    animationName: 'ai-chat-dot-wave',
    animationDuration: '950ms',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)'
  };
  return /*#__PURE__*/_jsxs(Box, {
    className: "flex flex-row items-end space-x-2",
    children: [/*#__PURE__*/_jsx("img", {
      src: "https://storage.googleapis.com/jove-public-images/ai/ai-avatar.png",
      className: "h-10 w-10 rounded-full object-cover",
      alt: "AI avatar"
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex max-w-[85%] flex-col space-y-1",
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        className: "font-medium leading-3 text-[#707070]",
        children: "Mia"
      }), /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-row items-center space-x-2 rounded-lg bg-[#EBEFFE] px-4 py-3 text-[#0E35D1] shadow-sm",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "body2",
          className: "leading-6 text-[#0E35D1]",
          children: "Mia is typing..."
        }), /*#__PURE__*/_jsxs(Box, {
          className: "flex flex-row items-center space-x-1",
          sx: {
            '@keyframes ai-chat-dot-wave': {
              '0%': {
                opacity: 0.25,
                transform: 'scale(0.45)'
              },
              '45%': {
                opacity: 1,
                transform: 'scale(1.25)'
              },
              '100%': {
                opacity: 0.25,
                transform: 'scale(0.45)'
              }
            }
          },
          children: [/*#__PURE__*/_jsx("span", {
            style: _objectSpread(_objectSpread({}, dotAnimationStyles), {}, {
              animationDelay: '0ms'
            })
          }), /*#__PURE__*/_jsx("span", {
            style: _objectSpread(_objectSpread({}, dotAnimationStyles), {}, {
              animationDelay: '160ms'
            })
          }), /*#__PURE__*/_jsx("span", {
            style: _objectSpread(_objectSpread({}, dotAnimationStyles), {}, {
              animationDelay: '320ms'
            })
          })]
        })]
      })]
    })]
  });
};

export default AIChatAnalyzingIndicator;